export default __webpack_public_path__ + "static/keith1-616fa322cca71a9587b298c8471ac131.jpg";